import { makeApiCall } from "../apiRequest";

export default {
  state: {
    requestLogList: [],
  },
  getters: {
    getAllRequestLogs: (state) => state.requestLogList,
  },
  actions: {
    async getAllRequestLogs({ commit }, payload) {
      const response = await makeApiCall(
        `apiRequestLog/getAll`,
        "POST",
        payload
      );
      if (!response.error) {
        commit("setRequestLogList", response.data.data);
      }
      return response;
    },
  },
  mutations: {
    setRequestLogList(state, payload) {
      state.requestLogList = payload;
    },
  },
};
